import React from 'react';
import PropTypes from 'prop-types';
import {Label} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {isNoU} from "../../utils/DBUtils";

const ErrorDisplay = ({error}) => {
    if (isNoU(error)) {
        return null;
    }

    if (error.errorCode === "INVALID_VALUE") {
        return error.failedValidations.map((failedValidation) => (
            <Label key={failedValidation.name} basic className="db-error-label">
                <FormattedMessage id={`errors.validation.${failedValidation.name}`}/>&nbsp;
                {failedValidation.invalidValues ? (
                    <FormattedMessage id='errors.validation.invalid_values' values={{invalidValues: failedValidation.invalidValues}}/>
                ) : ""}

            </Label>
        ));
    }

    return (
        <Label basic className="db-error-label">
            <FormattedMessage id={`errors.${error.errorCode}`}/>&nbsp;
        </Label>
    )
};

ErrorDisplay.propTypes = {
    error: PropTypes.object
};

export default ErrorDisplay;



// WEBPACK FOOTER //
// ./public/components/common/ErrorDisplay.jsx